export default class MassiaNavigationService {
	static $inject = ['_', 'MassiaRightsService', 'MassiaApplicationService', 'MassiaClientService', 'MassiaAuthService', 'PersonnesService'];

	constructor(_, MassiaRightsService, MassiaApplicationService, MassiaClientService, MassiaAuthService, PersonnesService) {
		this._ = _;
		this.MassiaRightsService = MassiaRightsService;
		this.MassiaApplicationService = MassiaApplicationService;
		this.MassiaClientService = MassiaClientService;
		this.MassiaAuthService = MassiaAuthService;
		this.PersonnesService = PersonnesService;
		this.items = [];
	}

	setItems(values = []) {
		this.items.splice(0, this.items.length);
		values.forEach(this.addItem, this);
	}

	getItems() {
		return this.items;
	}

	clearItems() {
		this.items = [];
	}

	addItem(config = {}, activite) {
		if (config && config.id) {
			const index = this._.findIndex(this.items, { id: config.id });

			if (index >= 0) {
				this.items[index] = this.createItem(config, activite);
			} else {
				this.items.push(this.createItem(config, activite));
			}
		}
	}

	// Vérifie si un item appartient à l'activité courante
	isItemForCurrentActivity(item, activite) {
		// Si l'item n'a pas de droits définis, il est pour toutes les activités
		if (!item.rights || !item.rights.application) {
			return true;
		}

		// Vérifier si l'activité courante est dans la liste des applications autorisées
		const applications = item.rights.application.split(';');
		return applications.indexOf(activite) >= 0;
	}

	createItem(config, activite) {
		const children = (config.items || [])
			.filter((child) => {
				// On masque uniquement les applications non licenciées
				if (
					(child.id == 'applications_gestion' && (activite == 'gestion' || !__configuration.licenceGest)) ||
					(child.id == 'applications_performance' && (activite == 'performance' || !__configuration.licencePerf)) ||
					(child.id == 'applications_qse' && (activite == 'qse' || !__configuration.licenceQse)) ||
					(child.id == 'applications_laboratoire' && (activite == 'laboratoire' || !__configuration.licenceLaboratoire))
				) {
					return false;
				}

				// Masquer les items qui n'appartiennent pas à l'activité courante
				if (!this.isItemForCurrentActivity(child, activite)) {
					return false;
				}

				// On garde tous les autres items (même sans droits)
				return child;
			})
			.map((child) => {
				// On crée l'item en vérifiant les droits
				const childItem = this.createItem(child, activite);

				if (child.hasNoDomainMetier === true) {
					childItem.hasNoDomainMetier = true;
				}

				// Si child avait déjà un disabled défini AVANT le createItem, on le restaure
				// car createItem peut l'avoir écrasé
				if (child.disabled === true) {
					childItem.disabled = true;
				}
				// Sinon, si childItem.disabled n'est pas déjà défini par createItem (via config.disabled)
				// alors on vérifie les droits ici
				else if (childItem.disabled === undefined || childItem.disabled === false) {
					const hasRights =
						child.rights === undefined ||
						this.MassiaRightsService.userHasRight(child.rights.domain, child.rights.right, child.rights.application);
					const hasClientAccess =
						child.clientRestriction === undefined || child.clientRestriction.indexOf(this.MassiaClientService.getClient()) >= 0;

					childItem.disabled = !hasRights || !hasClientAccess;
				}
				childItem.isVisible = true;

				// Si l'item est disabled, on vérifie si on doit l'afficher quand même
				if (childItem.disabled) {
					// ------------------------------------------------------------ //
					//TODO : récupérer le parametre boolean "afficher tous les menus" dans le/les profil de l'utilisateur ADO 15948
					let isDisplayAllItems = true;
					// ------------------------------------------------------------ //
					childItem.isVisible = isDisplayAllItems;
				}

				return childItem;
			});

		const item = {
			id: config.id,
			type: config.type,
			icon: config.icon,
			navigationCls: config.navigationCls,
			translate: config.translate,
			translateCls: config.translateCls,
			sref: config.sref,
			href: config.href,
			collapse: config.collapse,
			position: config.position || 'left',
			order: config.order || 0,
			header: config.header || false,
			divider: config.divider || false,
			items: children.length ? children : undefined,
			rights: config.rights,
			clientRestriction: config.clientRestriction
		};

		for (const p in config) {
			if (p.startsWith('href_')) {
				item[p] = config[p];
			}
		}

		return item;
	}

	// removeItem(id, recursive) { }
}
